import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-tags-form-field-old',
  templateUrl: './tags-form-field-old.component.html',
  styleUrls: ['./tags-form-field-old.component.scss']
})
export class TagsFormFieldOldComponent  {
  currentTagText: '';
  selectable = true;
  removable = true;
  error: string;

  @Input() allowOverrides: boolean;
  @Input() tags: string[];
  @Input() originalTags: string[];
  @Output() tagsChanged = new EventEmitter<string[]>();
  @Output() editModeChanged = new EventEmitter<boolean>();

  constructor(
    private translate: TranslateService,
  ) {
  }

  onEnter($event) {
    if(!this.validate()){
      return;
    }
    $event.preventDefault();
    this.tags = [...this.tags, this.currentTagText];
    this.currentTagText = '';

    this.tagsChanged.emit(this.tags);
  }

  onRemoveTag(deletedTag: string) {
    this.tags = this.tags.filter(item => item !== deletedTag);
    this.tagsChanged.emit(this.tags);
  }

  changeEditMode(editMode: boolean) {
    this.editModeChanged.emit(editMode);
  }

  isTagsDifferent() : boolean {
    if (this.tags && this.originalTags) {
      return [...this.tags].sort().toString() !== [...this.originalTags].sort().toString();
    }

    return !!((this.tags && !this.originalTags) || (!this.tags && this.originalTags));
  }

  clearTags() {
    this.tags = this.originalTags;
    this.tagsChanged.emit(this.tags);
  }

  private validate() {
    if(!this.currentTagText){
      this.error = "Can't be empty";
      return false;
    }

    if(this.tags.find(tag => tag.trim() === this.currentTagText)){
      this.error = "Should be unique";
      return false;
    }

    this.error = null;
    return true;
  }
}
